const $ = require('jquery');
const _ = require('lodash');

module.exports = class OnScrollAnimation {
  constructor ($element) {
    this.$element = $element;
    this.watch();
  }

  watch () {
    $(window).on('scroll', () => this.onScroll());
  }

  onScroll () {
    if (this.getAnimationType() === 'parallax') {
      this.translateY(this.offsetTop());
    } else if (this.getAnimationType() === 'slide-in-from-left') {
      this.translateX(this.offsetTop());
    }
  }

  isInViewport () {
    const rect = this.$element[0].getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (
        window.innerHeight || document.documentElement.clientHeight
      ) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  offsetTop () {
    const bounding = this.$element[0].getBoundingClientRect();
    return bounding.top;
  }

  translateX (offsetTop) {
    if (offsetTop < innerHeight * 2 / 3) {
      this.$element.addClass('animate__animated')
        .addClass('animate__slideInLeft');
    }
  }

  translateY (offsetTop) {
    const innerHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const height = this.$element[0].getBoundingClientRect().height;
    let y = _.clamp(
      height * (offsetTop / innerHeight) - height / 2,
      -height / 2,
      height / 3
    );
    this.$element.css(
      'transform',
      `translateY(${y}px)`
    );
  }

  getAnimationType () {
    return this.$element.data('onscrollanimation');
  }
}